import { atom } from 'jotai';

/** Per-project context of a copilot-escalated run. */
export interface CopilotRunContext {
  /** The Heidi session the run was escalated FROM (drives the toolbar). */
  sessionId?: string;
  /**
   * The escalating note's patient — the redaction subject bound to the run's
   * executor session. Presence also drives the registry's durable
   * `requiresRedactions` marker (fail-closed restore).
   */
  patientName?: string;
}

/**
 * Map of Projects run (project) id → its copilot escalation context.
 *
 * Written by `CopilotIntentHost` (the one place that durably knows the ids —
 * the run's linked session is NOT echoed on the `ProjectDetail` response, and
 * the `note-push-verification` artifact carries no sessionId). Read by the
 * active-note publisher (toolbar liveness in a run view), the background
 * registration (redaction marker), and the executor attach (redaction values).
 *
 * Patient-safety: readers consult it only for the project they are acting on,
 * so a stale entry can never publish another patient's note off-route.
 */
export const copilotRunContextByProjectAtom = atom<Record<string, CopilotRunContext>>({});
